/**
 * @ngdoc class
 * @name Media
 * @description
 * This class represent a Media.
 *
 * @memberof common
 */
class Media {
  /**
   * Class constructor.
   * @param {Object} media The necesary data to build the Media.
   * @ignore
   */
  constructor(media) {
    /**
     * The media EXIF orientation code.
     * @type {Object}
     */
    this.MEDIA_ORIENTATION = {
      LANDSCAPE: 1,
      PORTRAIT: 6,
    };
    /**
     * The local reference to the `id` property.
     * @type {String}
     */
    this.id = media.id;
    /**
     * The local reference to the `images` property.
     * @type {Object}
     */
    this.images = media.images || {};
    /**
     * The local reference to the `publisher` property.
     * @type {Object}
     */
    this.publisher = media.publisher;
    /**
     * The local reference to the `campaign` property.
     * @type {Object}
     */
    this.campaign = media.campaign;
    /**
     * The local reference to the `caption` property.
     * @type {String}
     */
    this.caption = media.caption || '';
    /**
     * The local reference to the `created_at` property.
     * @type {String}
     */
    this.createdAt = media.created_at;
    /**
     * The local reference to the `orientation` property.
     * @type {Array}
     */
    this.orientation = this._getOrientation(this.images.normal);
    /**
     * The media status; check constant MEDIA_STATUSES.
     * @type {String}
     */
    this.status = media.status;
    /**
     * The media file
     * @type {Object}
     */
    this.file = media.file;
  }
  /**
   * Extract the first caracter of the asset's url which indicate
   * the photo orientation.
   *
   * @param {String} url The asset's url.
   *
   * @return {Number} The orientation code from the asset.
   */
  _getOrientation(url) {
    if (!url) {
      return this.MEDIA_ORIENTATION.LANDSCAPE;
    }

    const parts = url.match(/https(.+)files\/([0-9]{1})/);
    return parts ? parseInt(parts[2], 10) : this.MEDIA_ORIENTATION.LANDSCAPE;
  }
  /**
   * Change data of the media.
   * @param  {Object} newData The new Media data;
   */
  setData(newData) {
    Object.keys(newData).forEach((key) => {
      this[key] = newData[key];
    });

    // If the images objected changed, get the orientation property.
    if (newData.images) {
      this.orientation = this._getOrientation(this.images.normal);
    }
  }
}

export default Media;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/models/media.js